<template>
  <div class="container mt-5">
    <div class="card text-center">
      <div class="card-body py-5">
        <div v-if="loading">
          <div class="spinner-border text-primary mb-3"></div>
          <h5>Vérification du paiement...</h5>
        </div>
        
        <div v-else-if="success" class="text-success">
          <i class="fas fa-check-circle fa-4x mb-3"></i>
          <h4>Rechargement réussi !</h4>
          <p>Votre compte a été crédité avec succès.</p>
          <router-link to="/listePrepaidAccount" class="btn btn-primary mt-3">
            Voir mon compte
          </router-link>
        </div>
        
        <div v-else class="text-danger">
          <i class="fas fa-times-circle fa-4x mb-3"></i>
          <h4>Échec du rechargement</h4>
          <p>{{ errorMessage }}</p>
          <router-link to="/listePrepaidAccount" class="btn btn-secondary mt-3">
            Retour
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import { loadStripe } from '@stripe/stripe-js';

export default defineComponent({
  name: 'PrepaidRechargeSuccess',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const loading = ref(true);
    const success = ref(false);
    const errorMessage = ref('');

    const verifyPayment = async () => {
      try {
        const intentId = route.query.intentId as string;
        const provider = route.query.provider as string;
        const paymentIntentId = route.query.payment_intent as string; // Stripe ajoute ça dans l'URL

        if (!intentId || !provider) {
          throw new Error('Paramètres manquants');
        }

        if (provider === 'stripe' && paymentIntentId) {
          // Vérifier avec Stripe
          const publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || 
            'pk_test_51JDXTeGXfBDkYkwpKxt2AjIL2ZXSXWGGkqXJpjNKwGTW0AjZJIONLDUYVa3TyY1QSveflJWBkc4n0Suu05bE9TJM00aeMQAQlI';
          
          const stripe = await loadStripe(publishableKey);
          if (!stripe) throw new Error('Erreur Stripe');

          const { paymentIntent } = await stripe.retrievePaymentIntent(route.query.payment_intent_client_secret as string);
          
          if (paymentIntent?.status === 'succeeded') {
            // Confirmer côté backend
            await ApiService.post('/prepaid/recharge/stripe/confirm', {
              stripeIntentId: paymentIntentId,
              intentId: intentId
            });
            success.value = true;
          } else {
            throw new Error('Paiement non confirmé');
          }
        }
      } catch (error: any) {
        console.error('Erreur vérification:', error);
        errorMessage.value = error.message || 'Erreur lors de la vérification';
        success.value = false;
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      verifyPayment();
    });

    return { loading, success, errorMessage };
  }
});
</script>